export enum SourceType {
	Forecasted = "Forecasted",
    Cadence = "Cadence",
	Requested = "Requested"
}

export const SourceTypeLabels = [
	{
		id: SourceType.Forecasted,
		label: SourceType.Forecasted
	},
	{
		id: SourceType.Cadence,
		label: SourceType.Cadence
	},
	{
		id: SourceType.Requested,
		label: SourceType.Requested
	}
]
